import React from "react";
import Banner from "./Banner/Banner";
import OurAchievements from "./OurAchievements/OurAchievements";
import LatestatIhub from "./LatestatIhub/LatestatIhub";
import { FocusArea } from "./FocusArea/FocusArea";

export default function Home() {
  console.log("its a banner components")
  return (
    <>
      {/* Banner Component */}
      <Banner />
      {/* home page About Us section */}
      {/* <AboutUs /> */}
      {/* Focus Areas */}
      <FocusArea style={{ overflow: 'hidden' }}/>
      {/* Our Achievements section */}
      <OurAchievements style={{ overflow: 'hidden' }}/>
      {/* home event slider */}
      <LatestatIhub />
    </>
  );
}
